<template>
  <BarChartWithLabel
    v-bind:title="title"
    v-bind:data="data"
    v-bind:labels="labels"
    v-bind:ratio="labels.length > 10 ? true : false"
  />
</template>

<script>
import BarChartWithLabel from "@/components/management/statistics/common/BarChartWithLabel";
import { getAccessByFunctionChartData } from "@/api/statisticsV2";

export default {
  components: {
    BarChartWithLabel,
  },
  data() {
    return {
      title: "Access by Function",
      data: [],
      labels: [],
    };
  },
  methods: {
    async getData(startDate, endDate) {
      let loader = this.$loading.show({});
      try {
        let response = await getAccessByFunctionChartData(startDate, endDate);
        this.labels = response.data.name;
        this.data = response.data.count;
      } finally {
        loader.hide();
      }
    },
  },
};
</script>

<style></style>
